import src from "IMAGE";
export default { src, width: 284, height: 70, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42hXKsQ0AEAAF0V+KOSQKBYlIMJYJbP6d4l11sn3QsTAxsBEhkYuMgoqGhPCHB7HLMr2TaG7MAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 2 }
